import { default as deserialize } from 'app/utils/deserialize'
import FormErrors from 'app/utils/form_errors'
import { fetch } from 'app/utils/data'

export default {
  namespaced: true,

  state: {
    list: []
  },

  mutations: {
    pageviewDomainsFetched(state, { pageviewDomains }) {
      state.list = pageviewDomains
    }
  },

  actions: {
    async fetchPageviewDomains({ commit }, id) {
      try {
        const response = await fetch({ url: `/api/clouds/kits/pageview-domains/${id}` })

        const pageviewDomains = await deserialize(response.data)

        commit('pageviewDomainsFetched', { pageviewDomains })

        return pageviewDomains
      } catch (error) {
        throw new FormErrors(error.response.data.errors)
      }
    },

    async fetchAggregatePageviewDomains({ commit }, { year, month } = {}) {
      try {
        let url = `/api/clouds/kits/pageview-domains`
        if (year && month) {
          url += `?year=${year}&month=${month}`
        }
        const response = await fetch({ url })

        const pageviewDomains = await deserialize(response.data)

        return pageviewDomains
      } catch (error) {
        throw new FormErrors(error.response.data.errors)
      }
    }
  }
}
